import React from 'react';
import { v4 as uuidv4 } from 'uuid';
import Box from '../../components/Box';
import Link from '../../components/Link';
import Typography from '../../components/Typography';
import Widget from '../../components/Widget';
import { IClassNames } from '../../hooks/classNames.hooks';
import { translate } from '../../i18n';
import { useSettings } from './hooks';

interface MySettingsWidgetProps extends IClassNames {}

const MySettingsWidget: React.FC<MySettingsWidgetProps> = ({ ...props }) => {
  const mySettings = useSettings();

  return (
    <Widget title="dashboard.widget.mySettings.title" unstyled {...props}>
      <div className="u-margin-top">
        {mySettings.map((link) => (
          <Box key={uuidv4()}>
            <Typography variant="h3" as="h6" classNames="u-margin-bottom-xs">
              {translate(link.title)}
            </Typography>

            {link.description && (
              <Typography classNames="u-margin-bottom-xs">{translate(link.description)}</Typography>
            )}

            <Link to={link.to}>{translate(link.linkText)}</Link>
          </Box>
        ))}
      </div>
    </Widget>
  );
};

export default MySettingsWidget;
